import { render, staticRenderFns } from "./WizardHead.vue?vue&type=template&id=d4d38df2&"
import script from "./WizardHead.vue?vue&type=script&lang=js&"
export * from "./WizardHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports